const operatorToken = process.env.REACT_APP_ZAIN_TOKEN;

export const guestHeader = () => {
  return {
    "x-api-key": operatorToken,
  };
};

export function authHeader(accessToken) {
  
  // let accessToken = JSON.parse(localStorage.getItem("userDetails")).accessToken;
  // let accessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjI3NWE1YzczLTZlYjktNDJjMS05NTI1LWQ1ZWU5YmQ0Nzk1NCIsImVtYWlsIjoiaHVzYW1AZW1haWwuY29tIiwicGhvbmVOdW1iZXIiOiI5MjA5MTU1NjAiLCJwYXNzd29yZCI6IiQyYSQwOCREckNYbXczWU8zYWY1OXVHSDg3UEouTWlXZklPOHpiRGxnS2NoSnMwRWJHVHJnZzYyQmZuYSIsInVzZXJuYW1lIjoiaHVzYW0zMiIsImZpcnN0TmFtZSI6Ikh1c2FtIiwibGFzdE5hbWUiOiJHaGllcyIsImVtYWlsVmVyaWZpZWRBdCI6bnVsbCwicGhvbmVOdW1iZXJWZXJpZmllZEF0IjpudWxsLCJhdmF0YXIiOm51bGwsImNvdmVyUGhvdG8iOm51bGwsInRlYW0iOm51bGwsImxvY2F0aW9uIjpudWxsLCJiaW8iOm51bGwsImFjdGl2ZSI6dHJ1ZSwicm9sZSI6IkFETUlOIiwiY29uZmlybWF0aW9uVG9rZW4iOm51bGwsInJlc2V0VG9rZW4iOm51bGwsIk9UUCI6bnVsbCwib3BlcmF0b3IiOiJ6YWluIiwiY3JlYXRlZEF0IjoiMjAyMi0wMS0yMFQxMjoxMzowMy4wMDBaIiwidXBkYXRlZEF0IjoiMjAyMi0wMS0yMFQxMjoxMzowMy4wMDBaIiwiaWF0IjoxNzQxNjA0MTMxLCJleHAiOjE3NDE3NzY5MzF9.Pu265FjWAM7IFVrGWmQ3DJjikYZvldvg4CgWpwueQ666"

  if (accessToken) {
    return {
      Authorization: "Bearer " + accessToken,
      "x-api-key": operatorToken,
    };
  } else {
    return { "x-api-key": operatorToken };
  }
}

export const authHeaderWithMultipart = (accessToken) => {
  // let accessToken = JSON.parse(localStorage.getItem("userDetails")).accessToken;

  if (accessToken) {
    return {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "multipart/form-data",
      "x-api-key": operatorToken,
    };
  } else {
    return {
      "Content-Type": "multipart/form-data",
      "x-api-key": operatorToken,
    };
  }
};
